import { ActionTypes } from 'utils/constants';

export const resources = (state = {}, action) => {
    switch(action.type) {
        case ActionTypes.FETCH_RESOURCES + '_PENDING': {
            return {
                ...state,
                fetching: true
            };
        }
        case ActionTypes.FETCH_RESOURCES + '_FULFILLED': {
            const resources = action.payload.data.resources;
            
            return {
                ...state,
                fetching: false,
                fetched: true,
                resources
            };
        }
        case ActionTypes.FETCH_RESOURCES + '_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }
        default: {
            return state;
        }
    }
};
